import { render } from "./permission-modal.vue?vue&type=template&id=7f233a73"
import script from "./permission-modal.vue?vue&type=script&lang=ts"
export * from "./permission-modal.vue?vue&type=script&lang=ts"
script.render = render

export default script